module.exports = __webpack_public_path__ + "static/media/Colorectal-New Patient Intake-1@3x.42e2bad0.png";